import { AnswerTypes } from '../../enums';
import Radio from './Radio/Radio';

export const answerMap = {
  [AnswerTypes.RADIO]: Radio,
};
